import { getNestedSubelementsByType, getMostRecentFieldValue } from '@fs/zion-sls'
/**
 * An array of string constants representing the field type keys of name parts allowed in the Essential Information Card.
 * These are used for checkbox functionality and represent FIELD types, not intermediate element types.
 * @type {string[]}
 */

export const namePartTypeKeys = ['NAME_PRE', 'NAME_GN', 'NAME_PATR', 'NAME_MATR', 'NAME_SPRE', 'NAME_SURN', 'NAME_SUF']

/**
 * An array of strings representing the type keys of person details allowed in the Essential Information Card
 *
 * @type {string[]}
 */

export const personDetailTypeKeys = ['SEX_CODE', 'RACE_OR_COLOR', 'AGE']

export const getFieldTypeValuesObjects = (person, fieldTypesArray) => {
  if (!person || !fieldTypesArray || !Array.isArray(fieldTypesArray)) {
    return []
  }
  const fieldElements = fieldTypesArray.flatMap((fieldType) => getNestedSubelementsByType(person, fieldType, true))
  const fieldTypeValuesObjects = fieldElements.map((fieldElement) => {
    return {
      fieldType: fieldElement.fieldType,
      fieldValue: getMostRecentFieldValue(fieldElement),
    }
  })
  return fieldTypeValuesObjects
}
